import { AnswerType, ICategory } from "../models";

export const round99: ICategory[] = [
	{
		id: "1qxjh6uk1sbd7yc",
		name: "Famous Hackers",
		answers: [
			{
				id: "1qxjh6uk1sbd7yj",
				type: AnswerType.TEXT,
				answer:
					'This individual spent 8 months in solitary confinement, because law enforcement officials convinced a judge that he had the ability to "start a nuclear war by whistling into a pay phone"',
				question: "Who is Kevin Mitnick",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yq",
				type: AnswerType.TEXT,
				answer:
					"This scientist was tasked to track down a .75 cent discrepancy on a dial up phone bill and subsequently discovered the largest cyber attack against the United States. He also wrote a book about it.",
				question: "Who is Cliff (Clifford) Stoll (Cuckoo's Nest)",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yx",
				type: AnswerType.TEXT,
				answer:
					'This individual released an XSS Worm which became the fastest spreading virus of all time, run by over 1 million users within 20 hours, carrying a payload which read “but most of all, ___ is my hero"',
				question: "Who is Samy Kamkar",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z4",
				type: AnswerType.TEXT,
				answer: "The creator of metasploit.",
				question: "Who is H.D. Moore",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zb",
				type: AnswerType.TEXT,
				answer:
					'This family social engineer said "I have been offered 3 pardons from 3 different standing Presidents and I refused them all because I do not believe that a piece of paper excuses what I did.”',
				question: "Who is Frank Abagnale",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zi",
				type: AnswerType.TEXT,
				answer:
					'A legendary phone phreak, this individual became known as "Captain Crunch" after learning that a toy whistle packaged in boxes of Cap\'n Crunch cereal emitted a tone of precisely 2600 hertz',
				question: "Who is John Draper",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjh6uk1sbd7yd",
		name: "Protocols",
		answers: [
			{
				id: "1qxjh6uk1sbd7yk",
				type: AnswerType.TEXT,
				answer:
					"Residing on the transport layer, this protocol features reliable, ordered, error-checked delivery of a stream of octets between programs running on computers connected to a local area network, intranet or the public Internet",
				question: "What is Transmission Control Protocol (TCP)",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yr",
				type: AnswerType.TEXT,
				answer:
					"This protocol uses a simple connectionless communication mode, with no handshaking dialogues.",
				question: "What is User Datagram Protocol (UDP)",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yy",
				type: AnswerType.TEXT,
				answer:
					"This protocol is used for resolution of network layer addresses into link layer addresses",
				question: "What is Address Resolution Protocol (ARP)",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z5",
				type: AnswerType.TEXT,
				answer:
					"This network protocol was designed as a replacement for unsecured remote shell protocols",
				question: "What is Secure Shell (SSH)",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zc",
				type: AnswerType.TEXT,
				answer:
					"This computer networking protocol provides shared access to files, printers, and serial ports, and was later renamed to CIFS.",
				question: "What is Server Message Block (SMB)",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zj",
				type: AnswerType.TEXT,
				answer:
					"This IPv6 protocol operates at the link layer and is responsible for address autoconfiguration of nodes.",
				question: "What is Neighbor Discovery Protocol",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjh6uk1sbd7ye",
		name: "Big Numbers",
		answers: [
			{
				id: "1qxjh6uk1sbd7yl",
				type: AnswerType.TEXT,
				answer: "One billion has this many zeroes.",
				question: "What is nine?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7ys",
				type: AnswerType.TEXT,
				answer: "This is equal to just under 10 trillion kilometers (or about 6 trillion miles).",
				question: "What is a light year?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yz",
				type: AnswerType.TEXT,
				answer: "Kilo, mega, giga, tera; this is the next consecutive unit in measuring bytes.",
				question: "What is a petabyte",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z6",
				type: AnswerType.TEXT,
				answer: "A human being's functional memory is estimated to be this large.",
				question: "What is 1.25 Terabytes",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zd",
				type: AnswerType.TEXT,
				answer: "This measurement unit is equal to 1000 zettabytes.",
				question: "What is a Yottabyte",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zk",
				type: AnswerType.TEXT,
				answer:
					"Written in decimal form, this amount looks like this: 1,208,925,819,614,629,174,706,176 , and is equal to 1024 zebibytes",
				question: "What is a Yobibyte.",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjh6uk1sbd7yf",
		name: "P - Words",
		answers: [
			{
				id: "1qxjh6uk1sbd7ym",
				type: AnswerType.TEXT,
				answer: "Unencrypted information is said to be stored in this format",
				question: "What is plaintext",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yt",
				type: AnswerType.TEXT,
				answer:
					"This attack technique involves fraudulent attempts to obtain sensitive information via email",
				question: "What is Phishing",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z0",
				type: AnswerType.TEXT,
				answer:
					"This slag term describes the culture of people who experimented, exposed, and compromised the telephone system",
				question: "What is Phreaking",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z7",
				type: AnswerType.TEXT,
				answer:
					"This attack technique results in the redirection of legitimate website traffic to another fake website",
				question: "What is Pharming",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7ze",
				type: AnswerType.TEXT,
				answer: "This packet has a protocol of 1 and a type of 8",
				question: "What is ICMP (or Ping)",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zl",
				type: AnswerType.TEXT,
				answer:
					'This popular network attack is (ab)used by the "Circle with Disney" network device for parental control purposes',
				question: "What is ARP Poisoning (or ARP Spoofing). ",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjh6uk1sbd7yg",
		name: "IPs and Networks",
		answers: [
			{
				id: "1qxjh6uk1sbd7yn",
				type: AnswerType.TEXT,
				answer: "The number of bytes in an IPv4 address",
				question: "What is 4",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yu",
				type: AnswerType.TEXT,
				answer: "Private IPv4 addresses were set as a standard in this RFC.",
				question: "What is RFC 1918",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z1",
				type: AnswerType.TEXT,
				answer: "A netmask of 255.255.255.240 (or /28) has how many usable hosts?",
				question: "What is 14",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z8",
				type: AnswerType.TEXT,
				answer:
					"A technology for securing Internet Protocol (IP) communications by authenticating and/or encrypting each IP packet of a communication session is known as what?",
				question: "What is IPSec",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zf",
				type: AnswerType.TEXT,
				answer: "The subnet 224.0.0.0/4 is reserved for what use?",
				question: "What is IP Multicast",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zm",
				type: AnswerType.TEXT,
				answer:
					"This Internet Protocol, written and released on April 1, 1990 in RFC 1149, transmits large amounts of data with high latency and packet loss.",
				question: "What is Internet Protocol over Avian Carrier (IPoAC)",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjh6uk1sbd7yh",
		name: "Crypto",
		answers: [
			{
				id: "1qxjh6uk1sbd7yo",
				type: AnswerType.TEXT,
				answer: "This simple cipher shifts each character by a given value     ",
				question: "What is a Caesar cipher (substitution cipher, rotation cipher)",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yv",
				type: AnswerType.TEXT,
				answer: "This is the effective keysize of the DES cipher",
				question: "What is 56 bits (7 bytes)",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z2",
				type: AnswerType.TEXT,
				answer: "This cipher was used incorrectly, creating a weakness in the security of WEP",
				question: "What is RC4",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z9",
				type: AnswerType.TEXT,
				answer: "The two fish and three fish ciphers were invented by this crytographer",
				question: "Who is Bruce Schneier",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zg",
				type: AnswerType.TEXT,
				answer:
					"This now defunct chipset, utilizing the Skipjack algorithm, was developed promoted by the NSA from 1993-1996 to allow Federal, State, and local law enforcement officials the ability to decode intercepted voice and data transmissions.",
				question: 'What is the "Clipper chip"',
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zn",
				type: AnswerType.TEXT,
				answer: "This attack occurs when",
				question: "What is a collision",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjh6uk1sbd7yi",
		name: "Windows Commands",
		answers: [
			{
				id: "1qxjh6uk1sbd7yp",
				type: AnswerType.TEXT,
				answer:
					"This command displays active TCP connections, ports on which the computer is listening, does not resolve IP addresses and lists the processes that opened the connections.",
				question: "What is netstat -ano",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7yw",
				type: AnswerType.TEXT,
				answer: "This command displays environment variables in a command shell.",
				question: "What is set",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7z3",
				type: AnswerType.TEXT,
				answer:
					"This is the command used to remove the hidden attribute from a file or directory. (Please provide correct switch syntax in your response)",
				question: "What is attrib -h",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7za",
				type: AnswerType.TEXT,
				answer: "This command communicates with the service controller and installed services.",
				question: "What is sc",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zh",
				type: AnswerType.TEXT,
				answer:
					"This is Microsoft's task automation framework, consisting of a command line shell and associated scripting language built on the .NET framework.",
				question: "What is PowerShell",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			},
			{
				id: "1qxjh6uk1sbd7zo",
				type: AnswerType.TEXT,
				answer:
					"Which command allows for you to display all file associations from the command-line?",
				question: "What is assoc",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			}
		]
	}
];
